/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//

let _baseUrl = '';

export const setBaseUrl = (baseUrl: string) => (_baseUrl = baseUrl);

export const getBaseUrl = () => _baseUrl;
